import { render } from "./TopbarView.vue?vue&type=template&id=23ef36e1"
import script from "./TopbarView.vue?vue&type=script&lang=js"
export * from "./TopbarView.vue?vue&type=script&lang=js"

import "./TopbarView.vue?vue&type=style&index=0&id=23ef36e1&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__